// extracted by mini-css-extract-plugin
module.exports = {"ErrorWrapper":"ErrorSearch_ErrorWrapper__3EMKk"};